const { keyBy } = require('lodash');

class SearchPhraseActionService {
    constructor($state, $window, $timeout, $q, Restangular, moveFocus, bootstrap, settings, loginService, shopperService, searchMultisearchService, searchService, analyticsService) {
        this.$state = $state;
        this.$window = $window;
        this.$timeout = $timeout;
        this.$q = $q;
        this.api = Restangular.one('Search');
        this.moveFocus = moveFocus;
        this.settings = settings;
        this.loginService = loginService;
        this.shopperService = shopperService;
        this.multisearchService = searchMultisearchService;
        this.searchService = searchService;
        this.analyticsService = analyticsService;

        this.action = {
            login: 'PromptLogin',
            navigate: 'GoToUrl',
        };

        if (bootstrap.isBootstrapped(bootstrap.bootstrapped.SearchPhraseActions)) {
            this.setSearchPhraseActions.call(this, bootstrap.getBootstrappedData(bootstrap.bootstrapped.SearchPhraseActions));
        }
    }

    setSearchPhraseActions(searchPhraseActions) {
        this.searchPhraseActions = keyBy(searchPhraseActions.SearchPhraseActions, searchPhraseAction => searchPhraseAction.Phrase.toLowerCase());
    }

    getSearchPhraseAction(searchTerm) {
        if (this.searchPhraseActions) {
            return this.$q.when(searchTerm.toLowerCase() in this.searchPhraseActions && this.searchPhraseActions[searchTerm.toLowerCase()]);
        }

        return this._api.one('SearchPhraseAction').get({
            SearchTerm: searchTerm,
        });
    }

    actionPromptsForLogin(searchPhraseAction) {
        return searchPhraseAction.Action === this.action.login && this.shopperService.IsGuest;
    }

    performSearchPhraseAction(searchPhraseAction) {
        return this.$q((resolve, reject) => {
            if (this.actionPromptsForLogin(searchPhraseAction)) {
                this.moveFocus('#loginForm-Email');
                return this.loginService.promptForLogin(this.loginService.LoginToContinueMessage).then(resolve);
            } else if (searchPhraseAction.Action === this.action.navigate) {
                this.analyticsService.push({
                    data: {
                        type: 'external',
                        searchKeyword: searchPhraseAction.Phrase,
                    },
                    type: this.analyticsService.mapperTypes.search.result,
                });
                // A timeout is imposed just in case of the page get redirected before the data can be pushed to analytics provider.
                // Frontend setting externalRedirectionDelay is introduced, specifying the milliseconds taken to delay the redirection.
                // Ideally the analytics push should return a promise and the redirection should take place in the callback.
                this.$timeout(() => {
                    if (searchPhraseAction.Target === 'Blank') {
                        this.$state.go('shop.search.external-result', { searchTerm: searchPhraseAction.Phrase }, { inherit: false });
                        this.$window.open(searchPhraseAction.URL, '_blank');
                    } else {
                        this.$window.location.href = searchPhraseAction.URL;
                    }
                }, this.settings.search.externalRedirectionDelay);
                return reject();
            }
            return resolve();
        });
    }

    searchRequiresLogin(searchPhrase) {
        return this.$q((resolve) => {
            if (!searchPhrase || searchPhrase === '') {
                resolve(false);
            }
            this.getSearchPhraseAction(searchPhrase).then((action) => {
                if (action) {
                    resolve(this.actionPromptsForLogin(action) && !this.multisearchService.isSearchMultisearch());
                }
                resolve(false);
            });
        });
    }
}

SearchPhraseActionService.$inject = ['$state', '$window', '$timeout', '$q', 'Restangular', 'MoveFocus', 'BootstrapService', 'Settings', 'LoginService', 'ShopperService', 'SearchMultisearchService', 'SearchService', 'AnalyticsService'];

module.exports = { SearchPhraseActionService };



// WEBPACK FOOTER //
// ./src/search/search-phrase-action.service.js